module.exports = __webpack_public_path__ + "img/H4.8f554cbb.png";